package com.cybersoftsolution.cybersoftsolutionweb.styles

import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.mouseOverColor
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.selectedColor
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.unselectedColor
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.ms

val NavigationItemStyleCss = CssStyle {




    cssRule(":hover > #${IdConst.svgParentIcon} > #${IdConst.vectorIcon}") {

        Modifier
            .color(mouseOverColor)
            .styleModifier {
                property("stroke", "$mouseOverColor")
//                property("stroke-width", "5")
            }
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
    }


    cssRule(" > #${IdConst.navigationText}true") {
        Modifier
            .color(selectedColor)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
    }

    cssRule(" > #${IdConst.navigationText}false") {
        Modifier
            .color(unselectedColor)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
    }

    cssRule(":hover > #${IdConst.navigationText}true") {
        Modifier
            .color(mouseOverColor)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
    }

    cssRule(":hover > #${IdConst.navigationText}false") {
        Modifier
            .color(mouseOverColor)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
    }



//    cssRule(" > #${id.navigationText}") {
//        Modifier
//            .color(unselectedColor)
//            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
//    }
//    cssRule(":hover > #${id.navigationText}") {
//        Modifier
//            .color(mouseOverColor)
//            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
//
//    }
}

//val NavigationTextSelectedStyle = CssStyle {
//    base {
//        Modifier
//            .color(selectedColor)
//            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
//    }
//
//    hover {
//        Modifier
//            .color(mouseOverColor)
//            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
//    }
//}
//
//val NavigationTextUnSelectedStyle = CssStyle {
//
//
//    base {
//        Modifier
//            .color(unselectedColor)
//            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
//    }
//
//    hover {
//        Modifier
//            .color(mouseOverColor)
//            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
//    }
//}
//
//val NavigationIconStyle = CssStyle {
//
////    base {
//////        Modifier
////////            .color(unselectedColor)
//////            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
//////            .styleModifier {
//////                property(propertyName = "stroke", value ="${mouseOverColor}")
//////            }
////    }
//
//    hover {
//        Modifier
////            .color(unselectedColor)
//            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
//            .styleModifier {
//                property(propertyName = "stroke", value ="${mouseOverColor}")
//            }
//    }
//}
